import { Collapse, CollapseProps } from "antd";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import s from "./FiltersPopOverContent.module.scss";
type PropType = {
  setFilter: (filter: {
    active: boolean;
    disabled: boolean;
    all: boolean;

    revoked: boolean;
  }) => void;
  filter: {
    active: boolean;
    disabled: boolean;
    all: boolean;

    revoked: boolean;
  };
};
function FiltersPopOverContent({ filter, setFilter }: PropType) {
  const [activeKey, setActiveKey] = useState<string>();

  const [filterDraft, setFilterDraft] = useState<{
    active: boolean;
    all: boolean;
    disabled: boolean;
    revoked: boolean;
  }>({
    active: false,
    all: true,
    disabled: false,
    revoked: false,
  });

  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "Status",
      children: (
        <div className={clsx(s.options, { [s.active]: activeKey === "1" })}>
          <p
            className={clsx(s.checkboxOption, {
              [s.active]: filterDraft?.active,
            })}
            onClick={() =>
              setFilterDraft((prev) => ({
                disabled: false,
                all: false,
                deleted: false,
                revoked: false,
                active: !prev?.active,
              }))
            }
          >
            Active
          </p>
          <p
            className={clsx(s.checkboxOption, {
              [s.active]: filterDraft.disabled,
            })}
            onClick={() =>
              setFilterDraft((prev) => ({
                active: false,
                all: false,
                deleted: false,
                revoked: false,

                disabled: !prev.disabled,
              }))
            }
          >
            Disabled
          </p>
          <p
            className={clsx(s.checkboxOption, {
              [s.active]: filterDraft.revoked,
            })}
            onClick={() =>
              setFilterDraft((prev) => ({
                active: false,
                all: false,
                deleted: false,
                disabled: false,

                revoked: !prev.revoked,
              }))
            }
          >
            Revoked
          </p>
         
          <p
            className={clsx(s.checkboxOption, {
              [s.active]: filterDraft.all,
            })}
            onClick={() =>
              setFilterDraft((prev) => ({
                active: false,
                disabled: false,
                deleted: false,
                revoked: false,
                all: !prev.all,
              }))
            }
          >
            All
          </p>
        </div>
      ),
    },
  ];
  const handleRest = () => {
    setFilterDraft({
      active: false,
      disabled: false,
      all: true,
      revoked: false,
    });

    setFilter({
      active: false,
      disabled: false,
      all: true,
      revoked: false,
    });
  };
  const handleApply = () => {
    setFilter(filterDraft);
  };
  const onChange = (key: string | string[]) => {
    if (Array.isArray(key)) {
      // collapse closed (empty array), reset state
      setActiveKey(key[0]);
    } else {
      setActiveKey(key);
    }
  };
  useEffect(() => {
    setFilterDraft(filter);
  }, [filter]);
  return (
    <div className={s.wrapper}>
      <span className={s.title}>Filters</span>{" "}
      <Collapse items={items} accordion ghost onChange={onChange} />
      <div className={s.btnWrapper}>
        <button className={s.resetBtn} onClick={handleRest}>
          Reset
        </button>
        <button className={s.applyBtn} onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
}

export default FiltersPopOverContent;
